module.exports = __webpack_public_path__ + "static/media/mag5.59c3d6a8.jpg";